import React, { useState } from "react";

export type AuthConfig = {
  mode: "local" | "company";
  capabilities: Record<string, boolean>;
  legal?: { termsUrl: string; privacyUrl: string };
};

export function CodeField({
  value,
  onChange,
  onSend,
  cooldown,
  busy,
  sendDisabled = false,
  inputRef,
  error,
  errorId
}: {
  value: string;
  onChange: (value: string) => void;
  onSend: () => void;
  cooldown: number;
  busy: boolean;
  sendDisabled?: boolean;
  inputRef?: React.Ref<HTMLInputElement>;
  error?: string;
  errorId?: string;
}) {
  return (
    <label>
      验证码
      <span className="auth-code-row">
        <input
          ref={inputRef}
          aria-label="验证码"
          aria-invalid={Boolean(error) || undefined}
          aria-describedby={error && errorId ? errorId : undefined}
          value={value}
          onChange={(event) => onChange(event.target.value)}
          inputMode="numeric"
          autoComplete="one-time-code"
          placeholder="请输入验证码"
        />
        <button type="button" className="auth-code-button" disabled={busy || cooldown > 0 || sendDisabled} onClick={onSend}>
          {busy ? "发送中…" : cooldown > 0 ? `${cooldown} 秒` : "获取验证码"}
        </button>
      </span>
      {error && errorId && <span id={errorId} className="auth-field-error" role="alert">{error}</span>}
    </label>
  );
}

export function PasswordField({ label = "密码", value, onChange, autoComplete = "current-password" }: {
  label?: string;
  value: string;
  onChange: (value: string) => void;
  autoComplete?: string;
}) {
  const [visible, setVisible] = useState(false);
  return (
    <label>
      {label}
      <span className="auth-password-row">
        <input
          aria-label={label}
          value={value}
          type={visible ? "text" : "password"}
          onChange={(event) => onChange(event.target.value)}
          autoComplete={autoComplete}
          placeholder={`请输入${label}`}
        />
        <button type="button" onClick={() => setVisible((current) => !current)} aria-label={visible ? `隐藏${label}` : `显示${label}`}>
          {visible ? "隐藏" : "显示"}
        </button>
      </span>
    </label>
  );
}
